import { makeAutoObservable } from "mobx";
import { ICarrier } from "../return-method-types";
import { IOption } from "../../../components/inputs/select-dropdown/select-dropdown";
import { ICheckboxesTreeItem } from "../../../components/inputs/checkboxes-tree-dropdown/checkboxes-tree/stores/checkboxes-tree-store";


export class CarrierOptionsCacheStore {
    
    /** options for carrier selections for store CarrierSelectionOptionsStore */
    private _carriersAndServices: { [key: string]: ICheckboxesTreeItem[] } = {};

    /** options for default carriers store DefaultCarrierSelectorStore */
    private _packages: { [key: string]: IOption[] } = {};
    private _services: { [key: string]: IOption[] } = {};
    private _carriers: { [key: string]: IOption[] } = {};

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public setPackagesOptions(connectionId: number, carrierCode: string, serviceCode: string, list: ICarrier[]) {
        const options = list.map(pack => ({
            label: pack.name,
            value: pack.code,
        }));
        const key = `${connectionId}-${carrierCode}-${serviceCode}`;
        this._packages[key] = options;
    }

    public getPackagesOptions(connectionId: number|null|undefined, carrierCode: string|null|undefined, serviceCode: string|null|undefined): IOption[] {
        const key = `${connectionId}-${carrierCode}-${serviceCode}`;
        return this._packages[key] ?? [];
    }

    public setServicesOptions(connectionId: number|null|undefined, carrierCode: string|null|undefined, list: ICarrier[]) {
        const options = list.map(service => ({
            label: service.name,
            value: service.code,
        }));
        const key = `${connectionId}-${carrierCode}`;
        this._services[key] = options;
    }    

    public getServicesOptions(connectionId: number|null|undefined, carrierCode: string|null|undefined): IOption[] {
        const key = `${connectionId}-${carrierCode}`;
        return this._services[key] ?? [];
    }    

    public setCarriersOptions(connectionId: number|null|undefined, list: ICarrier[]) {
        const options = list.map(service => ({
            label: service.name,
            value: service.code,
        }));
        const key = `${connectionId}`;
        this._carriers[key] = options;
    }    

    public getCarriersOptions(connectionId: number|null|undefined): IOption[] {
        const key = `${connectionId}`;
        return this._carriers[key] ?? [];
    }    


    /** options for carrier selections for store CarrierSelectionOptionsStore */
    public setCarriersAndServicesOptions(connectionId: number|null|undefined, options: ICheckboxesTreeItem[]): void {
        const key = `${connectionId}`;
        this._carriersAndServices[key] = options;
    }

    public getCarriersAndServicesOptions(connectionId: number|null|undefined): ICheckboxesTreeItem[] {
        const key = `${connectionId}`;
        return this._carriersAndServices[key] ?? [];
    }

}

